module.exports = __webpack_public_path__ + "static/media/post-hit.d6fac648.svg";